import * as React from 'react'

import { HintIndicator } from '../shared/hintIndicator'
import { useReadAloud } from '../readAloud/readAloudContext'
import { ReadAloudSection } from '../readAloud/readAloudSection'
import { UNSPOKEN_CLASS } from '../../libs/speech/speechText'
import { SMALL_ICON_BASE_SRC, } from '../../utils/constants'

function getClassName(description, leftBox, rightBox) {
  if (description && leftBox && rightBox) {
    return "concept-explanation"
  }
  return "concept-explanation empty"
}

const ConceptExplanation = ({ description, leftBox, rightBox, translatedExplanation, languageLocale }) => {
  const explanationRef = React.useRef<HTMLDivElement>(null)
  const { readAloudEnabled, } = useReadAloud()

  const translatedClassName = `concept-explanation-description translated${readAloudEnabled ? ` ${UNSPOKEN_CLASS}` : ''}`

  const explanation = (
    <React.Fragment>
      <div className="concept-explanation-description" dangerouslySetInnerHTML={{__html: description}} />
      {!!translatedExplanation?.description && <div className={translatedClassName} dangerouslySetInnerHTML={{ __html: translatedExplanation?.description }} lang={languageLocale} />}
      <div className="concept-explanation-see-write">
        <div className="concept-explanation-see" dangerouslySetInnerHTML={{__html: leftBox}} />
        <div className="concept-explanation-write" dangerouslySetInnerHTML={{__html: rightBox}} />
      </div>
    </React.Fragment>
  )

  return (
    <React.Fragment>
      <div className={getClassName(description, leftBox, rightBox)} ref={explanationRef}>
        <div className="concept-explanation-title"><img alt="" src={`${SMALL_ICON_BASE_SRC}/lightbulb.svg`} /><span>Hint</span></div>
        {readAloudEnabled && description ? <ReadAloudSection content={explanation} label="Read the hint aloud" /> : explanation}
      </div>
      <HintIndicator targetRef={explanationRef} />
    </React.Fragment>
  )
}

export { ConceptExplanation }
